/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResourcePermissionsResponse } from './ResourcePermissionsResponse';
import {
    ResourcePermissionsResponseFromJSON,
    ResourcePermissionsResponseFromJSONTyped,
    ResourcePermissionsResponseToJSON,
    ResourcePermissionsResponseToJSONTyped,
} from './ResourcePermissionsResponse';

/**
 * 
 * @export
 * @interface TournamentListItem
 */
export interface TournamentListItem {
    /**
     * 
     * @type {string}
     * @memberof TournamentListItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentListItem
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentListItem
     */
    location?: string;
    /**
     * 
     * @type {Date}
     * @memberof TournamentListItem
     */
    date?: Date | null;
    /**
     * Inclusive final tournament day; defaults to date for single-day tournaments.
     * @type {Date}
     * @memberof TournamentListItem
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TournamentListItem
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentListItem
     */
    teamsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentListItem
     */
    matchesCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentListItem
     */
    categoriesCount?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentListItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentListItem
     */
    creatorEmail?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentListItem
     */
    isInvitationOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentListItem
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentListItem
     */
    longitude?: number;
    /**
     * 
     * @type {ResourcePermissionsResponse}
     * @memberof TournamentListItem
     */
    permissions?: ResourcePermissionsResponse;
}

/**
 * Check if a given object implements the TournamentListItem interface.
 */
export function instanceOfTournamentListItem(value: object): value is TournamentListItem {
    return true;
}

export function TournamentListItemFromJSON(json: any): TournamentListItem {
    return TournamentListItemFromJSONTyped(json, false);
}

export function TournamentListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'location': json['location'] == null ? undefined : json['location'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'status': json['status'] == null ? undefined : json['status'],
        'teamsCount': json['teamsCount'] == null ? undefined : json['teamsCount'],
        'matchesCount': json['matchesCount'] == null ? undefined : json['matchesCount'],
        'categoriesCount': json['categoriesCount'] == null ? undefined : json['categoriesCount'],
        'description': json['description'] == null ? undefined : json['description'],
        'creatorEmail': json['creatorEmail'] == null ? undefined : json['creatorEmail'],
        'isInvitationOnly': json['isInvitationOnly'] == null ? undefined : json['isInvitationOnly'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'permissions': json['permissions'] == null ? undefined : ResourcePermissionsResponseFromJSON(json['permissions']),
    };
}

export function TournamentListItemToJSON(json: any): TournamentListItem {
    return TournamentListItemToJSONTyped(json, false);
}

export function TournamentListItemToJSONTyped(value?: TournamentListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'location': value['location'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString().substring(0,10),
        'status': value['status'],
        'teamsCount': value['teamsCount'],
        'matchesCount': value['matchesCount'],
        'categoriesCount': value['categoriesCount'],
        'description': value['description'],
        'creatorEmail': value['creatorEmail'],
        'isInvitationOnly': value['isInvitationOnly'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'permissions': ResourcePermissionsResponseToJSON(value['permissions']),
    };
}

